import { render } from "./StocksModal.vue?vue&type=template&id=36899d9e"
import script from "./StocksModal.vue?vue&type=script&lang=js"
export * from "./StocksModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__